import { cn } from 'helpers/classnames';
import useMartyContext from 'hooks/useMartyContext';

interface ReturnLabelOptionProps {
  badge?: React.ReactNode;
  checked: boolean;
  children: React.ReactNode;
  className: string;
  icon: string;
  id: string;
  optionTitle: string;
  optionInformation: React.ReactNode;
  onReturnMethodSelect: () => void;
  value: string;
  displayOnly: boolean;
  labelButtonsGroup: React.ReactNode;
}

const ReturnLabelOption = ({
  badge,
  checked,
  children,
  className,
  icon,
  id,
  optionTitle,
  optionInformation,
  onReturnMethodSelect,
  value,
  displayOnly,
  labelButtonsGroup
}: ReturnLabelOptionProps) => {
  const { testId } = useMartyContext();
  if (displayOnly) {
    return (
      <div className={cn('p-3 md:p-4', className)}>
        <div className="m-0">
          <div className="m-0 w-full">
            <div className="m-0 flex flex-grow flex-col">
              <p className="text-sm zappos:body-l">{optionTitle}</p>
              {optionInformation}
            </div>
            {labelButtonsGroup}
          </div>
        </div>
        {children}
      </div>
    );
  }

  return (
    <div
      data-test-id="return-label-option"
      className={cn('relative mb-4 rounded-lg border border-subtle p-6 md:mr-4', { 'border-base bg-default-subtle shadow-sm': checked, 'pt-12 md:pt-12': badge }, className)}
    >
      {badge && <div className="bg-secondary-color text-white absolute left-0 top-0 rounded-br-lg rounded-tl px-2 py-1 text-sm">{badge}</div>}
      <div className="mb-4 flex flex-row md:mb-0">
        <div className="flex md:items-center">
          <input
            checked={checked}
            onClick={onReturnMethodSelect}
            readOnly={true}
            type="radio"
            id={id}
            name="returnLabel"
            value={value}
            data-test-id={testId('selectRadioButton')}
            className="accent mr-3 h-[18px] w-[18px] shrink-0 border-moderate"
          />
          <img src={icon} alt={value} className="mr-4 hidden w-[60px] md:block" />
        </div>
        <div className="flex w-full md:mx-4 md:flex-col">
          <div className="flex flex-col md:mx-1 md:mb-2">
            <p className="text-sm zappos:body-l">{optionTitle}</p>
            {optionInformation}
          </div>
        </div>
        <span className="mt-[-4px] text-xs zappos:body-m">Free</span>
      </div>
      {children}
    </div>
  );
};

export default ReturnLabelOption;
